import Renderer from "./Renderer.js";

class ValutaRenderer extends Renderer {
    render() {
        if (!this.data) {
            return 0;
        }
        return parseFloat(this.data).toFixed(2);
    }
}

export default ValutaRenderer;
